import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import components from './components'
Vue.use(components)
import directive from './directive'
Vue.use(directive)
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)
const SDAU = require('./utils/SDAU').default
Vue.config.productionTip = false;
import Element from 'element-ui';
import './styles/element-variables.scss'
import './assets/scss/common.scss' //山东农大通用样式
import '@/styles/index.scss' // global css
import './assets/scss/theme.scss' // 主题
Vue.use(Element);
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
import { net } from '@/api/kevinRequest'
Vue.prototype.$net = net
Element.Select.props.filterable = {
  type: Boolean,
  default: true
};
Element.Select.props.clearable = {
  type: Boolean,
  default: true
};
Object.assign(Vue.prototype, {
  define: require('./utils/define'), // 常量
  SDAU, // 公共方法
  formValidate: require('./utils/formValidate').default, // 表单验证
})
//eventBus挂载
Vue.prototype.$eventBus = new Vue()
const vm = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
export default vm